import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const CakeIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 16, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2 9.86875C2.208 9.95875 2.436 10.0048 2.66667 10.0001C2.92633 10.0055 3.18342 9.94767 3.41572 9.83152C3.64802 9.71537 3.84855 9.54441 4 9.33342C4.15145 9.12242 4.35198 8.95147 4.58428 8.83532C4.81658 8.71917 5.07367 8.66131 5.33333 8.66675C5.593 8.66131 5.85008 8.71917 6.08238 8.83532C6.31469 8.95147 6.51522 9.12242 6.66667 9.33342C6.81811 9.54441 7.01865 9.71537 7.25095 9.83152C7.48325 9.94767 7.74034 10.0055 8 10.0001C8.25966 10.0055 8.51675 9.94767 8.74905 9.83152C8.98135 9.71537 9.18189 9.54441 9.33333 9.33342C9.48478 9.12242 9.68531 8.95147 9.91762 8.83532C10.1499 8.71917 10.407 8.66131 10.6667 8.66675C10.9263 8.66131 11.1834 8.71917 11.4157 8.83532C11.648 8.95147 11.8486 9.12242 12 9.33342C12.1514 9.54441 12.352 9.71537 12.5843 9.83152C12.8166 9.94767 13.0737 10.0055 13.3333 10.0001C13.5667 10.0048 13.7947 9.95875 14 9.86875M2 13.3334H14V8.00008C14 7.46965 13.7893 6.96094 13.4142 6.58587C13.0391 6.21079 12.5304 6.00008 12 6.00008H4C3.46957 6.00008 2.96086 6.21079 2.58579 6.58587C2.21071 6.96094 2 7.46965 2 8.00008V13.3334ZM8.00001 2.66675L8.97667 3.75875C9.15095 3.9461 9.26764 4.17965 9.3128 4.43151C9.35797 4.68338 9.32971 4.94292 9.2314 5.17916C9.13308 5.4154 8.96887 5.61836 8.75835 5.76382C8.54784 5.90928 8.29991 5.99109 8.04417 5.99948C7.78842 6.00788 7.53566 5.94251 7.31606 5.81118C7.09645 5.67984 6.91928 5.48809 6.80568 5.25881C6.69208 5.02953 6.64685 4.7724 6.6754 4.51812C6.70395 4.26383 6.80506 4.02313 6.96667 3.82475L8.00001 2.66675Z"
          stroke="#1677FF"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
